
import React from "react";
import {
  Box,
  SimpleGrid,
  Stat,
  StatLabel,
  StatNumber,
  useColorModeValue,
  Heading,
  HStack,
  VStack,
  Text,
  Badge,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
} from "@chakra-ui/react";
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Tooltip,
  Legend,
  BarChart,
  Bar,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
} from "recharts";


/************************************  B2B KPI SUMMARY CARDS  ************************************/
export const B2BKpiSummaryCards = () => {
  const stats = [
    { label: "Qualified Accounts", value: 182 },
    { label: "Opportunities", value: 71 },
    { label: "Avg. Deal Size", value: "₹2.4 L" },
    { label: "Pipeline Value", value: "₹1.72 Cr" },
  ];

  const bg     = useColorModeValue("white", "gray.800");
  const border = useColorModeValue("gray.100", "gray.700");

  return (
    <SimpleGrid columns={{ base: 2, md: 4 }} gap={6}>
      {stats.map((stat) => (
        <Stat
          key={stat.label}
          p={4}
          bg={bg}
          border="1px"
          borderColor={border}
          rounded="xl"
          shadow="sm"
        >
          <StatLabel>{stat.label}</StatLabel>
          <StatNumber>
            {typeof stat.value === "number" ? stat.value.toLocaleString() : stat.value}
          </StatNumber>
        </Stat>
      ))}
    </SimpleGrid>
  );
};
